import React from "react";
import AddOnsComponent from "./AddOnsComponent";
import {
  CATEGORY_LIST,
  LIST_ADDON,
  ADDON,
  UPDATE_ADDON,
  DELETE_ADDON,
} from "../../Network/ApiPaths";
import Uri from "../../Network/Uri";
import postClientDataResponse from "../../Network/PostClientDataResponse";
import getResponseClient from "../../Network/GetClientDataResponse";
let storeFresh;
let clientHost;
class AddOnsContainer extends React.Component {
  constructor(props) {
    super();
    const client = window.localStorage.getItem("clientAccess");
    storeFresh = JSON.parse(client);
    if (storeFresh !== null) {
      clientHost = JSON.parse(window.localStorage.getItem("clientAccess")).host;
    }
    this.state = {
      subCategories: [],
      categories: [],
      selectedCatId: "",
      selectedSubCatId: "",
      collapse: false,
      cName: "all",
      uprice_regular: "",
      // onUpdateDetails: "",
      name: "",
      price_regular: "",
      store: "",
      type: "",
      description: "",
      tax: "",
      itemDefaultDetails: "",
      itemDefaultPrices: "",
      newName: "",
      newprice_regular: "",
      newStore: "",
      newType: "",
      newDesc: "",
      newTax: "",
      updatedName: "",
      updatedprice_regular: "",
      updatedStore: "",
      updatedType: "",
      updatedDesc: "",
      updatedTax: "",
      dID: "",
      dPID: "",
      newPriceQuantity: "",
      newPriceMeasure: "",
      newPrice: "",
      newPriceOffer: "",
      newPID: "",
      priceQuantity: "",
      priceMeasure: "",
      pricePrice: "",
      priceOffer: "",
      new: false,
      deletedSubCat: false,
      editCat:false,
    };
  }
  selectedCatID = (sCatId, sCatName) => {
    this.setState({
      selectedCatId: sCatId,
      cName: sCatName,
      collapse: true,
    });
    this.getSubCategories(sCatId);
  };
  next = (offset) => {
    if (this.state.selectedCatId === "") {
      this.setState({
        subCategories: [],
      });
    } else {
      var apiPath = new Uri(
        clientHost +
          `Category/listSubCategoriesAdmin?category_id=${this.state.selectedCatId}&limit=10&offset=${offset}`
      );
      getResponseClient(
        apiPath,
        (onSuccessResponse) => {
          this.setState({
            subCategories: onSuccessResponse.result,
          });
        },
        (onError) => {
          alert(onError.message);
        }
      );
    }
  };

  fieldChange = (e) => {
     this.setState({ [e.target.name]: e.target.value });
    // this.setState({ [e.target.price_regular]: e.target.value });
  };
  onUpdateDetails = (e) => {
  //   alert(
  //     this.state.itemDefaultDetails +
  //       this.state.updatedName +
  //       this.state.updatedprice_regular 
       
  //   );

  let updatedName;
  let updatedprice_regular;
  
  
  updatedName = this.state.updatedName;

  updatedprice_regular = this.state.updatedprice_regular;
  
  
  if (
    (updatedName === "" || this.state.name) &&
    (updatedprice_regular === "" || this.state.price_regular) 
  ) 
  {
    alert("no new prices are changed");
  } 
  else {
    let productData = this.state.selectedCat;
    console.log(productData.id);
    const requestBody = {
      id: productData.id,
      name: updatedName,
      price_regular: updatedprice_regular,
      store_id: storeFresh.storeId,
    };
  }

   };

  onSubCategoryDelete = (e) => {
    var apiPath = new Uri(
      clientHost + `Menu/deleteSubCategory?id=${this.state.dID}`
    );
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        alert(onSuccessResponse);
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };

  onSubCategoryDetails = (e) => {
    console.log(e);
    // e.preventDefault();
    this.setState({
      itemDefaultDetails: e,
    });
  };
  onNameUpdate = (e) => {
    this.setState({ newName: e.target.value });
    this.setState({ newprice_regular:e.target.value})
    
  };
  onAddNewSubCategory = () => {
    if (
      this.state.newprice_regular === "" ||	
      this.state.newprice_regular === null ||	
      this.state.newprice_regular === undefined ||	
      this.state.newName === "" ||	
      this.state.newName === null ||	
      this.state.newName === undefined
    ) {
      alert("Enter Name");
    } 
     
    else {
      const requestBody = {
        category_id: this.state.selectedCatId,
        name: this.state.newName,
        price_regular:this.state.newprice_regular,
        store_id: this.state.newStore,
      };
      postClientDataResponse(
        clientHost + UPDATE_ADDON,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          // alert(onSuccessResponse);
          // console.log(onSuccessResponse);
          this.getSubCategories(this.state.selectedCatId);
        },
        (onError) => {
          console.log(onError);
        }
      );
    }
  };
  getSubCategories = (selectedCatId) => {
    var apiPath = new Uri(clientHost + ADDON)
      .addQueryParam("category_id", selectedCatId)
      .addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        // console.log(
        //   onSuccessResponse.result.filter((q) => q.info.category_id === sid)
        // );
        // if (onSuccessResponse.status === true) {
        // this.setState({
        //   subCategories: onSuccessResponse.result,
        //   // collapse: false,
        //   // new: true,
        // });
        // } else {
        this.setState({
          subCategories: onSuccessResponse.result,
          collapse: false,
          new: true,
        });
        //    }
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  // getSubCategories = (sid) => {
  //   var apiPath = new Uri(clientHost + SUBCATEGORY_LIST)
  //     .addQueryParam("catId", sid)
  //     .addQueryParam("store_id", storeFresh.storeId);
  //   getResponseClient(
  //     apiPath,
  //     storeFresh.key,
  //     (onSuccessResponse) => {
  //       this.setState({
  //         categories:onSuccessResponse.result.filter(
  //           (q) => q.info.category_id === sid),
  //         subCategories:onSuccessResponse.result.filter(
  //           (q) => q.info.category_id === sid),
  //             collapse:false,
  //             new:true,
  //       })

  //     },
  //     (onError) => {
  //       console.log(onError.message);
  //     }
  //   );
  // };
  onSubCategoryTriggerEdit = (p) => {
    this.setState({
      selectedCat: p,
    });
  };
  editCat = (c) => {
    // if (
    //   this.state.newName === "" ||
    //   this.state.newName === this.state.selectedCat.name
    // ) {
    //   alert("no newName to update");
    // }
    // else if 
    // (
    //   this.state.newprice_regular === "" ||
    //   this.state.newprice_regular === this.state.selectedCat.price_regular
    // )
    // {
    //   alert("no Prices to update");
    // }
    // else {
      let cid = this.state.selectedCat;
      const requestBody = {
        name: this.state.newName,
        price_regular: this.state.newprice_regular,
        addon_status: "ACTIVE",
        store_id: storeFresh.storeId,
        id: cid.id,
      };
      postClientDataResponse(
        clientHost + UPDATE_ADDON,
        storeFresh.key,
        requestBody,
        (onSuccessResponse) => {
          this.setState({
            editedCat: true,
          });
          this.getSubCategories(this.state.selectedCatId);
        },
        (onError) => {
          console.log(onError);
        }
      );
    // }
  };
  onSubCategoryTriggerDelete = (e) => {
    this.setState({
      dID: e,
    });
  };
  deleteSubCat = (e) => {
    this.setState({
      SubCatDeleted: true,
    });
    var apiPath = new Uri(clientHost + DELETE_ADDON).addQueryParam(
      "id",
      this.state.dID
    );
    // .addQueryParam(
    //   this.state.dID )
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        // this.setState({
        //   deletedCat: true,
        // });
        this.getSubCategories(this.state.selectedCatId);
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  };
  render() {
    return (
      <div>
        {/* {test} */}
        <AddOnsComponent
          data={this.state.subCategories}
          catData={this.state.categories}
          selectedCat={this.selectedCatID}
          catid={this.state.selectedCatId}
          cname={this.state.cName}
          uprice_regular={this.state.uprice_regular}
          collapse={this.state.collapse}
          next={this.next}
          fieldChange={this.fieldChange}
          onUpdateDetails={this.onUpdateDetails}
          onSubCategoryDetails={this.onSubCategoryDetails}
          onSubCategoryDelete={this.onSubCategoryDelete}
          subDefaultDetails={this.state.itemDefaultDetails}
          addNewSubCategory={this.onAddNewSubCategory}
          onSubCategoryTriggerEdit={this.onSubCategoryTriggerEdit}
          onSubCategoryTriggerDelete={this.onSubCategoryTriggerDelete}
          new={this.state.new}
          deletedSubCat={this.deletedSubCat}
          deleteSubCat={this.deleteSubCat}
          update={this.editCat}
          onNameUpdate={this.onNameUpdate}
          editedCat={this.state.editedCat}
        />
      </div>
    );
  }
  async componentDidMount() {
    var apiPath = new Uri(clientHost + CATEGORY_LIST)
    .addQueryParam("store_id",storeFresh.storeId);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (onSuccessResponse) => {
        this.setState({
          categories: onSuccessResponse.result,
        });
      },
      (onError) => {
        console.log(onError.message);
      }
    );
  }
}

export default AddOnsContainer;
